import { handleActions } from 'redux-actions';
import { sortObjectsByNameAsc } from '../../helpers/utils';
import * as types from './types';

const initialState = {
  data: [],
  error: null,
  initialLoad: false,
  loading: false,
  saving: false,
};

const getTimeTypesRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getTimeTypesRequestFailure = (state, action) => {
  return {
    ...state,
    data: [],
    error: action.error,
    loading: false,
  };
};
const getTimeTypesRequestSuccess = (state, payload) => {
  const data = payload.data;
  data.sort(sortObjectsByNameAsc);
  return {
    ...state,
    data,
    error: null,
    initialLoad: true,
    loading: false,
  };
};

export default handleActions(
  {
    [types.GET_TIME_TYPES_REQUEST]: getTimeTypesRequest,
    [types.GET_TIME_TYPES_REQUEST_FAILURE]: getTimeTypesRequestFailure,
    [types.GET_TIME_TYPES_REQUEST_SUCCESS]: getTimeTypesRequestSuccess,
  },
  initialState
);
